import { BaseField, BaseFieldModel } from '../baseField';
import { FieldType } from '../fieldType';

export interface ToggleFieldModel extends BaseFieldModel {
  defaultValue: boolean;
  type: FieldType.Toggle;
}
export class ToggleField extends BaseField implements ToggleFieldModel {
  public defaultValue = false;
  public type: FieldType.Toggle = FieldType.Toggle;

  constructor(cultures: string[]) {
    super(FieldType.Toggle, cultures);
  }
}
